import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Link } from '@optimus-web/core';
import { MessageResendWrapper } from './style';

interface MessageResendProps {
    onResend: () => void;
}

const MessageResend = ({ onResend }: MessageResendProps) => (
    <MessageResendWrapper>
        <LocalizedText textKey={TextKey.MessageNotSentErrorMessage} />
        <Link onClick={onResend} inherit as="button">
            <LocalizedText textKey={TextKey.Retry} />
        </Link>
    </MessageResendWrapper>
);

export default MessageResend;
